/**
 * Warm up lazy route chunks after the initial paint so navigation between
 * routes does not show a Suspense fallback flash. Runs once, idle-scheduled.
 */
let started = false;

export function preloadAllRoutes() {
  if (started || typeof window === 'undefined') return;
  started = true;

  const run = () => {
    // Fire all dynamic imports in parallel. Browser will dedupe with the
    // ones actually demanded by navigation, and failures here are silent.
    const imports: Array<Promise<unknown>> = [
      import('@/pages/Auth'),
      import('@/pages/SignupChoice'),
      import('@/pages/Activities'),
      import('@/pages/ActivityDetail'),
      import('@/pages/Categories'),
      import('@/pages/Favorites'),
      import('@/pages/Dashboard'),
      import('@/pages/dashboard/DashboardBookings'),
      import('@/pages/dashboard/DashboardAddresses'),
      import('@/pages/dashboard/DashboardPayments'),
      import('@/pages/dashboard/DashboardMyVote'),
      import('@/pages/dashboard/DashboardProfile'),
      import('@/pages/dashboard/DashboardSettings'),
      import('@/pages/dashboard/DashboardNotifications'),
      import('@/pages/InstructorDashboard'),
      import('@/pages/admin/AdminDashboard'),
      import('@/pages/schools/SchoolsDirectory'),
      import('@/pages/schools/SchoolDetail'),
      import('@/pages/Contact'),
      import('@/pages/About'),
      import('@/pages/FAQ'),
      import('@/pages/Terms'),
      import('@/pages/Privacy'),
      import('@/pages/CancellationPolicy'),
    ];
    imports.forEach((p) => p.catch(() => {}));
  };

  const ric: any = (window as any).requestIdleCallback;
  if (typeof ric === 'function') {
    ric(run, { timeout: 2500 });
  } else {
    setTimeout(run, 1500);
  }
}
